export default "__VITE_ASSET__B1XEb430__"